'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _defaultStyles = require('../default-styles');

var _defaultStyles2 = _interopRequireDefault(_defaultStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var overrideStyles = {
  compact: {
    maxWidth: 'calc(100% - 40px)',
    flexDirection: 'column'
  },
  audioContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },
  playerContainer: {
    flex: 1,
    position: 'relative'
  },
  progressContainer: {
    flex: 1,
    borderRadius: '3px',
    overflow: 'hidden',
    backgroundColor: '#DEDEDE'
  },
  bar: {
    width: '80%',
    backgroundColor: 'purple',
    height: '6px',
    borderRadius: '3px'
  },
  button: {
    width: '30px',
    height: '30px',
    padding: '6px',
    marginRight: '4px'
  },
  message: {
    width: '280px',
    display: 'flex',
    flexDirection: 'column'
  },
  time: {
    position: 'absolute',
    top: '10px',
    color: 'currentColor',
    fontSize: '12px',
    lineHeight: '12px',
    opacity: '.75'
  }
};

exports.default = (0, _merge2.default)({}, _defaultStyles2.default, overrideStyles);
module.exports = exports.default;